import React, { useContext } from "react";
import { ShoppingCart } from "../App";
import { FiShoppingCart } from "react-icons/fi";
import { NavLink, HashLink } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);
const Navbar = ({ onHome = true }) => {
  const { cart } = useContext(ShoppingCart);
  const links = [
    {
      name: "Our Process",
      url: "/about",
    },
    {
      name: "Reviews",
      url: "/testemonials",
    },
    {
      name: "Products",
      url: "/products",
    },
  ];
  return (
    <div className="navbar section-padding bg-base-100 w-full max-w-full">
      <div className="navbar-start">
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>
          <ul
            tabIndex={0}
            className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52"
          >
            {links.map((link, i) => (
              <NavLink
                key={i}
                to={link.url}
                onClick={() => {
                  console.log(onHome);
                  if (onHome)
                    gsap.to(window, {
                      duration: 1,
                      scrollTo: link.url.replace("/", "#"),
                    });
                }}
              >
                {link.name}
              </NavLink>
            ))}
          </ul>
        </div>
        <NavLink
          to={"/"}
          className="btn btn-ghost normal-case text-xl  hover:bg-base-100 h-max"
        >
          <svg
            className="w-8 h-8 lg:w-10 lg:h-10"
            viewBox="0 0 124 122"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_20_23726)">
              <rect
                width="91.1838"
                height="86.431"
                rx="14"
                transform="matrix(-0.311628 -0.950204 0.935954 -0.352123 42.5967 117.451)"
                fill="white"
                shapeRendering="crispEdges"
              />
              <path
                d="M83.1205 19.1304L50.1891 31.5198C36.2648 36.7584 28.7352 52.4648 33.3714 66.6012V66.6012C37.9934 80.6946 52.9679 87.9146 66.8697 82.7525L99.9566 70.4663"
                stroke="#000208"
                strokeWidth="5"
              />
              <path
                d="M99.0563 69.886V69.886C100.706 74.9174 98.0265 80.5076 93.0706 82.3721L69.5494 91.2212C55.7329 96.4192 40.8033 89.2621 36.203 75.2353V75.2353C31.6028 61.2085 39.074 45.6237 52.8905 40.4257L76.4117 31.5765C81.3676 29.712 84.0475 24.1218 82.3975 19.0905V19.0905"
                stroke="#000208"
                strokeWidth="5"
              />
              <g filter="url(#filter1_d_20_23726)">
                <path
                  d="M58.7514 10.1704L25.7831 22.5737C11.8588 27.8123 4.32921 43.5188 8.96534 57.6551V57.6551C13.5874 71.7485 28.5619 78.9685 42.4637 73.8063L75.5875 61.5064"
                  stroke="#000208"
                  strokeWidth="7"
                />
                <path
                  d="M73.1706 58.4459V58.4459C74.8207 63.4772 72.1408 69.0674 67.1849 70.9319L43.6636 79.781C29.8472 84.979 14.9175 77.8219 10.3173 63.7951V63.7951C5.71707 49.7683 13.1883 34.1835 27.0047 28.9855L50.526 20.1363C55.4819 18.2718 58.1618 12.6816 56.5117 7.65028V7.65028"
                  stroke="#000208"
                  strokeWidth="7"
                />
              </g>
              <rect
                x="0.624325"
                y="-1.30233"
                width="89.1838"
                height="84.431"
                rx="13"
                transform="matrix(-0.311628 -0.950204 0.935954 -0.352123 44.6345 116.283)"
                stroke="#C0C1D8"
                strokeWidth="2"
                shapeRendering="crispEdges"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_20_23726"
                x="0.143799"
                y="0.373291"
                width="127.348"
                height="125.078"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_20_23726"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_20_23726"
                  result="shape"
                />
              </filter>
              <filter
                id="filter1_d_20_23726"
                x="0.143799"
                y="6.41797"
                width="80.9673"
                height="86.606"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_20_23726"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_20_23726"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </NavLink>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal p-0">
          {links.map((link, i) => (
            <NavLink
              key={i}
              to={link.url}
              onClick={() => {
                console.log(onHome);
                if (onHome)
                  gsap.to(window, {
                    duration: 1,
                    scrollTo: link.url.replace("/", "#"),
                  });
              }}
            >
              {link.name}
            </NavLink>
          ))}
        </ul>
      </div>
      <div className="navbar-end">
        <div className="dropdown dropdown-end">
          <label tabIndex={0} className="btn btn-ghost btn-circle">
            <div className="indicator">
              <FiShoppingCart size={20} />
              <span className="badge badge-sm indicator-item">
                {cart.length}
              </span>
            </div>
          </label>
          <div
            tabIndex={0}
            className="mt-3 card card-compact dropdown-content w-52 bg-base-100 shadow"
          >
            <div className="card-body">
              <span className="font-bold text-lg"> Items: {cart.length}</span>
              <span className="text-base-200">
                Subtotal: $
                {cart.reduce((last, current) => last + current.price, 0)}
              </span>
              <div className="card-actions">
                <NavLink to="./checkout" className="btn btn-primary btn-block">
                  View cart
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
